import { render } from "./comparison-grid-large.vue?vue&type=template&id=16a85bfa"
import script from "./comparison-grid-large.vue?vue&type=script&lang=js"
export * from "./comparison-grid-large.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__